<template>
    <div>
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <app-breadcrumb :page-title="$t('brokers_list')" :directory="$t('list')" :icon="'grid'" />
                </div>
                <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                    <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                        <button 
                            @click=" addBroker = true, list = false"
                            type="button" class="btn btn-primary btn-with-shadow">
                            {{ $t('add_broker') }}
                        </button>
                    </div> 
                </div>
            </div>
            <app-table :id="tableId" :options="options" @action="getListAction" :selected-url="selectedUrl" />
        </div>
        <AddBroker 
            v-if="addBroker"
            @close="addBroker = false"
            @save="handleSaveBroker" />

        <EditBroker
            v-if="editBroker"
            :broker_id="this.rowData.id"
            @close="editBroker = false"
            @save="handleUpdateBroker" />    
    
        <app-delete-modal 
            v-if="deleteConfirmationModalActive" 
            :preloader="deleteLoader" 
            modal-id="demo-delete"
            @confirmed="confirmed" 
            @cancelled="cancelled" />

    </div>
</template>

<script>
import configTable from "./mixins/configTable.js";
import * as actions from "../../../Config/ApiUrl.js";
import { FormMixin } from '../../../../core/mixins/form/FormMixin.js';
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import AddBroker from "./AddBroker.vue";
import EditBroker from "./EditBroker.vue";
import { tableLocation } from './mixins/tableLPackers.js';
import { saveBroker, updateBroker, deleteBroker } from "./api/api.js";

export default {
    extends: CoreLibrary,
    mixins: [tableLocation, FormMixin],
    components :{
        AddBroker, EditBroker
    },  
    data() {
        return {
            tableId: 'advance-table',
            options: configTable,
            addBroker : false,
            editBroker : false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            rowData: {},
        }
    },
    created() {
        this.options.columns = this.tableColumns; // Asignar las columnas de la tabla
    },
    methods : {
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            if (actionObj.title === 'Delete') {
                this.openDeleteModal();
            }
            if (actionObj.title === 'Edit') {
                this.openEditModal();
            }
        },  

        async handleSaveBroker(data){
            const res = await saveBroker(data);
            if (res.created) {
                this.$toastr.s(res.message);
                this.addBroker = false;
                return;
            }
            this.$toastr.e(res.message);
        },

        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        cancelled() {
            this.deleteConfirmationModalActive = false;
            location.reload();
        },

        async confirmed() {
            const id = this.rowData.id;
            const res = await deleteBroker(id);
            if (res.deleted) {
                $("#demo-delete").modal('hide');
                this.$toastr.s(res.message);
                this.cancelled();
                return;
            }
            this.$toastr.e(res.message);
        },

        openEditModal() {
            this.editBroker = true;
        },

        async handleUpdateBroker(data){
            const res = await updateBroker(data);
            if (res.updated) {
                this.$toastr.s(res.message);
                this.editBroker = false;
                location.reload();
                return;
            }
            this.$toastr.e(res.message);
        }
    },
}
    
</script>

